import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import surveyImg from "../../../../assets/svg/aloop_ survey_illust.svg";
import surveyImg2 from "../../../../assets/svg/aloop_ survey_illust2.svg";
import CheckboxButton from "../../../components/CheckboxButton";
import CustomButton from "../../../components/CustomButton";
import ReturnButton from "../../../components/ReturnButton";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import { TypeOptions } from "./TypeOptions";
import { saveChangeJobStatus, checkDisplayNotification, updateTalentCondition } from "../../../reducers/talentNotification";
import { Fade } from "@mui/material";

const SurveyPopup = ({ open, onClose, onConfirm }: any) => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const {
        firstQuestionOptions,
        secondQuestionOptions,
        noAnswerOption,
        notFoundLabels,
    }: any = TypeOptions();
    const [next, setNext] = useState(false);
    const [secondQuestions, setSecondQuestions] = useState(secondQuestionOptions);
    const [firstAns, setFirstAns] = useState<any>(null);
    const [isComplete, setIsComplete] = useState(false);
    const {
        displayPopup,
    } = useSelector((state: any) => state.talentNotification);

    useEffect(() => {
        dispatch(checkDisplayNotification({}));
    }, []);

    if(!displayPopup) return;

    const handleChooseFirstAnswer = () => {
        if(firstAns.id){
            const data = {
                requestBody: {
                    change_job_status_id: parseInt(firstAns.id),
                }
            }
            dispatch(saveChangeJobStatus(data));
            setNext(true);
            return;
        }
        onClose();
    }

    const handleChooseNoAnswer = (answer: any) => {
        const data = {
            requestBody: {
                change_job_status_id: parseInt(answer.id),
            }
        }
        dispatch(saveChangeJobStatus(data));
        onClose();
    }

    const handleSubmit = () => {
        let expectedCondition = "";
        const answerCondition = secondQuestions.filter((item: any) => item.value).map((item: any) => item.label);
        expectedCondition = [...answerCondition, ...notFoundLabels].join(' | ');
        const data = {
            requestBody: {
                expected_condition: expectedCondition,
            }
        }
        dispatch(updateTalentCondition(data));
        setIsComplete(true);
    };

    return (
        <Modal open={open} onClose={onClose} 
            slotProps={{
                backdrop: {
                    timeout: 1000,
                },
            }}
        >
            <Fade in={open}>
            <div className="outline-none flex flex-col items-center bg-white rounded-2xl p-3 md:p-6 min-w-[370px] max-w-[370px] md:min-w-[450px] md:max-w-[480px] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] h-fit max-h-[calc(100dvh-6.25rem)] overflow-y-auto custom-scrollbar">
                <div className="w-full text-center mb-6 relative">
                    {next && !isComplete && (
                        <div className="flex items-center gap-4 absolute top-0 left-0">
                            <ReturnButton onClick={() => setNext(false)} />
                        </div>
                    )}
                    
                    {!isComplete && (
                        <h2 className="text-xl font-bold alu-text-base-2">
                            転職状況に関する
                            {next && <br className="md:hidden" />}
                            アンケート
                        </h2>
                    )}
                </div>
                {isComplete && (
                <h2 className="mb-6 text-xl font-bold alu-text-base-2 text-center">
                    ご回答ありがとうございました！
                </h2>
                )}
                <div className="mb-4">
                <img
                    src={!isComplete ? surveyImg : surveyImg2}
                    alt="survey"
                    className="w-[14.75rem] h-[9.0625rem] object-contain"
                />
                </div>
                {!isComplete && (
                <h2 className="text-xl font-bold text-[#009CF2] text-center md:text-left">
                    {!next ? (
                    <p className="mb-1">
                        あなたの転職状況を
                        <br className="md:hidden" />
                        教えてください
                    </p>
                    ) : (
                    <>
                        <p className="hidden md:block text-[#009CF2] mb-4">
                            次に転職するとしたら、希望するものはどれ
                            <br />
                            ですか？
                        </p>
                        <p className="md:hidden mb-4">
                            次に転職するとしたら、
                            <br />
                            希望するも のはどれですか？
                        </p>
                    </>
                    )}
                </h2>
                )}
                {!isComplete && !next && (
                <p className="text-xs alu-text-base-2 text-center mb-4 md:mb-4">
                    いただいた回答は「マイページ」の「転職状況」
                    <br className="md:hidden" />に反映されます。
                </p>
                )}
                {!next
                ? !isComplete && (
                    <>
                        <div className="mb-8 md:mb-4 flex flex-col gap-2 md:gap-4 md:hidden gap-x-2 gap-y-4 flex-wrap w-full justify-center">
                        {firstQuestionOptions.map((question: any, idx: number) => (
                            <button
                                onClick={() => {
                                    setFirstAns(question);
                                }}
                                key={idx}
                                className={`${
                                    firstAns?.id === question?.id
                                    ? "outline outline-1 outline-[#FF861A] bg-white"
                                    : "hover:bg-[#FFF3E5] hover:font-bold"
                                } outline-none w-full font-bold px-3 py-2 md:px-6 md:py-3 rounded-[2.5rem] bg-[#F7F7F7] text-center text-sm alu-text-base-2`}
                            >
                                {question.name}
                            </button>
                        ))}
                        </div>
                        <div className="mb-4 md:mb-6 hidden flex-col gap-2 md:gap-4 md:flex gap-x-2 gap-y-4 flex-wrap w-full justify-center">
                        {firstQuestionOptions.map((question: any, idx: number) => (
                            <button
                                onClick={() => {
                                    setFirstAns(question);
                                }}
                                key={idx}
                                className={`${
                                    firstAns?.id === question?.id
                                    ? "outline outline-1 outline-[#FF861A] bg-white"
                                    : "hover:bg-[#FFF3E5] hover:font-bold"
                                } outline-none w-full font-bold px-3 py-2 md:px-6 md:py-3 rounded-[2.5rem] bg-[#F7F7F7] text-center text-sm alu-text-base-2`}
                            >
                                {question.name}
                            </button>
                        ))}
                        </div>
                        <div className="w-full flex items-center justify-between">
                            <CustomButton
                                onClick={() => handleChooseNoAnswer(noAnswerOption)}
                                variant="text"
                            >
                                回答しない
                            </CustomButton>
                            <CustomButton
                                type="button"
                                disabled={!firstAns}
                                onClick={() => handleChooseFirstAnswer()}
                                customStyle="min-w-[9rem]"
                                size="md"
                            >
                                送信
                            </CustomButton>
                        </div>
                    </>
                    )
                : !isComplete && (
                    <>
                        <div className="p-[0.125rem] mb-6 flex flex-wrap md:gap-4 gap-x-2 gap-y-4 justify-center max-h-[10rem] overflow-auto custom-scrollbar lg:max-h-full">
                        {secondQuestions.map((question: any, idx: number) => (
                            <div
                                onClick={() => {
                                    const newList = secondQuestions.map((item: any, index: number) =>
                                    idx === index ? { ...item, value: !item.value } : item
                                    );
                                    setSecondQuestions(newList);
                                }}
                                key={idx}
                                className={`${
                                    question.value
                                    ? "outline outline-1 outline-[#FF861A] bg-white"
                                    : "bg-[#F7F7F7]"
                                } ${!['onsite', 'annual_income', 'headquarter_function', 'others'].includes(question.name) ? "w-full lg:w-[12.375rem]" : "w-full lg:w-[25.6875rem]"} text-sm rounded-[2.5rem] px-2 py-2 md:px-3 md:py-2 hover:bg-[#FFF3E5] hover:cursor-pointer`}
                            >
                                <CheckboxButton
                                    name={question.name}
                                    label={question.label}
                                    value={question.value}
                                    onChange={() => {
                                        const newList = secondQuestions.map((item: any, index: number) =>
                                            idx === index
                                            ? { ...item, value: !item.value }
                                            : { ...item }
                                        );
                                        setSecondQuestions(newList);
                                    }}
                                />
                            </div>
                        ))}
                        </div>
                        <div className="w-full flex justify-between items-center">
                            <CustomButton
                                onClick={() => setIsComplete(true)}
                                variant="text"
                            >
                                回答しない
                            </CustomButton>
                            <CustomButton
                                type="button"
                                disabled={secondQuestions.every((item: any) => !item.value)}
                                onClick={() => handleSubmit()}
                                size="md"
                                customStyle="min-w-[9rem]"
                            >
                                送信
                            </CustomButton>
                        </div>
                    </>
                    )}
                {isComplete && (
                <CustomButton
                    type="button"
                    onClick={() => onClose()}
                    size="md"
                    customStyle="min-w-[9rem]"
                >
                    閉じる
                </CustomButton>
                )}
            </div>
            </Fade>
        </Modal>
    );
};

export default SurveyPopup;
